module.exports = __webpack_public_path__ + "media/images/pic/sontag-aktuell-1079b9f7a4d1bf2e9b94a2d1721a08a0.png";